module.exports = __webpack_public_path__ + "img/requesteddoc.cdab4061.svg";